import React,{useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {
	useSelector
} from 'react-redux'
import {
	Link
} from "react-router-dom"
import {
	getComparisonPictures,
	getProgressPictures
} from './picturesSlice'
import CardDeck from 'react-bootstrap/CardDeck'
import Card from 'react-bootstrap/Card'
import {fullBasePath} from '../../util/util'
import classes from './Pictures.module.css'

const Pictures = props =>{
	const pics = useSelector(state=>state.pictures.pics)
	const comparisonPics = useSelector(state=>state.pictures.comparisonPics)
	const dispatch = useDispatch()
	useEffect(()=>{
		dispatch(getProgressPictures())
		dispatch(getComparisonPictures())
	},[])
	return (
		<React.Fragment>
			<div className="text-center my-3">
				<h2 className="shadow" style={{
					padding:'16px 32px',
					background:'#000C2D',
					color:'#eee',
					borderRadius:'100px',
					display:'inline-block'
				}}>
					<i style={{color:'#00ff8c'}} className="fas fa-images"></i> Pictures
				</h2>
			</div>
			<div className={classes.PicSnippet}>
				{pics.length?
					<Link to="/photo_reel">
						<img src={`${pics[0].img}`}/>
					</Link>
				:null}
				{comparisonPics.length?
					<Link to="/photo_reel">
						<img src={`${comparisonPics[0].comparisonImg}`}/>
					</Link>
				:null}
				<Link to="/photo_reel">
					<span>
						<i className="fa fa-clock mr-2"/>
						Progress Timeline
					</span>
				</Link>
			</div>
		</React.Fragment>
	)
}

export default Pictures